
var l = document.links;
for(var i=0; i < l.length; i++) {
    if(l[i].href.includes("?")) {
        l[i].href += "&" + window.location.search.substring(1);
    } else {
        l[i].href += window.location.search;
    }
}
